/* R2.2: interface-only finishing. No requests, storage, orders or email sends. */
(() => {
  'use strict';
  let dispose = () => {};
  function init() {
    dispose();
    const root = document.getElementById('yarn-r5');
    const form = root?.querySelector('[data-eoi-form]');
    if (!root || !form) return;
    const life = new AbortController();
    const links = [...root.querySelectorAll('a[href="#interest"]')].filter(a => /^Your selections/.test(a.textContent.trim()));
    const labels = links.map(a => a.textContent);
    const countChoices = () => {
      const count = [...form.querySelectorAll('[data-lines]>fieldset')].filter(row => row.querySelector('[data-product]')?.value).length;
      links.forEach((a, i) => { a.textContent = labels[i].replace('Your selections', 'Your selections' + (count ? ' (' + count + ')' : '')); });
    };
    const more = document.createElement('a');
    more.href = '#collection';
    more.className = 'r5-selection-continue';
    more.textContent = 'Continue exploring the collection';
    const anchor = form.querySelector('[data-summary]');
    if (anchor) anchor.after(more);
    const observer = new MutationObserver(countChoices);
    const lines = form.querySelector('[data-lines]');
    if (lines) observer.observe(lines, {childList:true, subtree:true});
    const summary = form.querySelector('[data-summary]');
    if (summary) observer.observe(summary, {childList:true, characterData:true, subtree:true});
    form.addEventListener('change', countChoices, {signal:life.signal});
    function clearOldSuccess() {
      form.querySelectorAll('[data-server-success]').forEach(el => { el.hidden = true; });
    }
    form.addEventListener('input', clearOldSuccess, {signal:life.signal});
    root.addEventListener('click', event => {
      const target = event.target.closest?.('[data-pdp-register],[data-add],[data-remove]');
      if (target) { clearOldSuccess(); queueMicrotask(countChoices); }
    }, {signal:life.signal});
    countChoices();
    dispose = () => {
      life.abort(); observer.disconnect(); more.remove();
      links.forEach((a, i) => { a.textContent = labels[i]; });
    };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', () => dispose());
})();
